module.exports = __webpack_public_path__ + "img/drammen.e7468bca.jpg";